const pending = new Set<string>();
const reported = new Set<string>();
let trackFn:
  | ((label: string, payload: Record<string, unknown>) => void)
  | null = null;
let flushScheduled = false;

const flush = (): void => {
  if (!trackFn || pending.size === 0) {
    return;
  }
  const flags = Array.from(pending);
  pending.clear();
  for (const flag of flags) {
    reported.add(flag);
  }
  trackFn("feature_flag_requested", { flags });
};

const scheduleFlush = (): void => {
  if (flushScheduled) {
    return;
  }
  flushScheduled = true;
  queueMicrotask(() => {
    flushScheduled = false;
    flush();
  });
};

export const initializeFeatureFlagUsageTracking = (
  fn: (label: string, payload: Record<string, unknown>) => void,
): void => {
  trackFn = fn;
  flush();
};

export const recordFeatureFlagRequested = (flag: string): void => {
  if (reported.has(flag) || pending.has(flag)) {
    return;
  }
  pending.add(flag);
  scheduleFlush();
};

export const resetFeatureFlagUsageTracking = (): void => {
  pending.clear();
  reported.clear();
  trackFn = null;
  flushScheduled = false;
};
